"use client";

import { useEffect } from "react";
import Link from "next/link";
import { ErrorPageShell } from "./ErrorPageShell";

type ErrorProps = {
  error: Error & { digest?: string };
  reset: () => void;
};

export default function Error({ error, reset }: ErrorProps) {
  useEffect(() => {
    console.error("[App Error]", error);
  }, [error]);

  return (
    <ErrorPageShell
      code="500"
      title="Internal Server Error"
      message="The requested URL caused an internal server error."
      note="If you get this message repeatedly please contact support@cloudaxe.io."
      variant="5xx"
      actions={
        <>
          <button
            type="button"
            onClick={() => reset()}
            className="inline-flex items-center justify-center rounded-full bg-slate-900 px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-slate-800"
          >
            Try Again
          </button>
          <Link
            href="/"
            className="inline-flex items-center justify-center rounded-full border border-slate-300 bg-white px-5 py-2.5 text-sm font-semibold text-slate-900 transition hover:bg-slate-50"
          >
            Return Home
          </Link>
        </>
      }
    />
  );
}
